/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkDeleteRequest } from '../models/BulkDeleteRequest';
import type { CreateEmbeddedVideoRequest } from '../models/CreateEmbeddedVideoRequest';
import type { ExerciseDetailResponse } from '../models/ExerciseDetailResponse';
import type { ExerciseInitUploadResponse } from '../models/ExerciseInitUploadResponse';
import type { ExerciseListResponse } from '../models/ExerciseListResponse';
import type { InitUploadRequest } from '../models/InitUploadRequest';
import type { UpdateExerciseRequest } from '../models/UpdateExerciseRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ExercisesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List videos
     * Get a list of videos for the current user or a specific customer (for trainers)
     * @returns ExerciseListResponse List of exercises
     * @throws ApiError
     */
    public getExercises({
        customerId,
        includeDeleted = 'false',
        search,
        equipment,
        difficulty,
        tags,
    }: {
        customerId?: string,
        includeDeleted?: 'true' | 'false',
        /**
         * Case-insensitive search on video title, description, and exercise instructions
         */
        search?: string,
        /**
         * Comma-separated equipment UUIDs; returns videos matching any
         */
        equipment?: string,
        /**
         * Filter by difficulty level
         */
        difficulty?: 'beginner' | 'intermediate' | 'advanced',
        /**
         * Comma-separated tag names; returns videos matching any (case-insensitive)
         */
        tags?: string,
    }): CancelablePromise<ExerciseListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/exercises',
            query: {
                'customerId': customerId,
                'includeDeleted': includeDeleted,
                'search': search,
                'equipment': equipment,
                'difficulty': difficulty,
                'tags': tags,
            },
            errors: {
                403: `Forbidden - no trainer-customer relationship`,
            },
        });
    }

    /**
     * Get exercise details
     * Get detailed information about a specific exercise including its video, bookmarks, and metadata
     * @returns ExerciseDetailResponse Exercise details
     * @throws ApiError
     */
    public getExercises1({
        id,
    }: {
        id: string,
    }): CancelablePromise<ExerciseDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/exercises/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden - insufficient permissions`,
                404: `Exercise not found`,
            },
        });
    }

    /**
     * Soft delete exercise
     * Mark an exercise's backing video as deleted. It remains accessible for 30 days, then becomes unavailable.
     * @returns any Exercise soft deleted
     * @throws ApiError
     */
    public deleteExercises({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        message: string;
        deletedAt: string;
        expiresAt: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/exercises/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden - insufficient permissions`,
                404: `Exercise not found`,
            },
        });
    }

    /**
     * Update exercise
     * Update an exercise's title, description, and/or metadata
     * @returns ExerciseDetailResponse Exercise updated successfully
     * @throws ApiError
     */
    public patchExercises({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: UpdateExerciseRequest,
    }): CancelablePromise<ExerciseDetailResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/exercises/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden - insufficient permissions`,
                404: `Exercise not found`,
            },
        });
    }

    /**
     * Bulk delete videos
     * Delete multiple videos and their R2 files
     * @returns any Bulk delete completed
     * @throws ApiError
     */
    public postExercisesBulkDelete({
        requestBody,
    }: {
        requestBody?: BulkDeleteRequest,
    }): CancelablePromise<{
        deleted: number;
        failed: Array<string>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/exercises/bulk-delete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Initialize a video upload for a new exercise
     * Create the exercise's backing video and get an upload URL
     * @returns ExerciseInitUploadResponse Upload initialized successfully
     * @throws ApiError
     */
    public postExercisesInitUpload({
        requestBody,
    }: {
        requestBody?: InitUploadRequest,
    }): CancelablePromise<ExerciseInitUploadResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/exercises/init-upload',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden - insufficient permissions`,
            },
        });
    }

    /**
     * Create an exercise from an embedded video
     * Create a customer-owned exercise backed by an embedded YouTube or Instagram URL.
     * @returns ExerciseDetailResponse Embedded exercise created
     * @throws ApiError
     */
    public postExercisesEmbed({
        requestBody,
    }: {
        requestBody?: CreateEmbeddedVideoRequest,
    }): CancelablePromise<ExerciseDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/exercises/embed',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Unsupported embed URL`,
                403: `Forbidden`,
            },
        });
    }

}
